import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../helpers'

type Props = {
  show: boolean
  onClose: () => void
  onDeliverFull: () => void
  onDeliverPartial: () => void
  taskName?: string
}

const DeliveryOptionsModal: FC<Props> = ({
  show,
  onClose,
  onDeliverFull,
  onDeliverPartial,
  taskName,
}) => {
  return (
    <Modal
      id='kt_modal_task_delivery_options'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={show}
      onHide={onClose}
      data-backdrop='static'
      className='bg-glass'
    >
      <div className='modal-header'>
        <h2 className='fw-bold'>Entregar tarefa</h2>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={onClose}
          role='button'
          aria-label='Fechar'
        >
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>
      <div className='modal-body'>
        <p className='text-gray-700 fs-6'>
          Esta tarefa possui mais de um responsável. Como deseja prosseguir?
        </p>
        {taskName && (
          <p className='text-gray-600 fs-7 mb-4'>
            <strong>Tarefa:</strong> {taskName}
          </p>
        )}
        <div className='d-flex flex-column gap-3'>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              onDeliverFull()
              onClose()
            }}
          >
            Entregar tarefa
          </button>
          <button
            type='button'
            className='btn btn-light-primary'
            onClick={() => {
              onDeliverPartial()
              onClose()
            }}
          >
            Entregar só pra mim
          </button>
        </div>
      </div>
    </Modal>
  )
}

export {DeliveryOptionsModal}
